import React, { useEffect } from 'react';
import FormAfterSignUp from '../features/formAfterSignUp';
import '../App.css';

const FormAfterSignUpPage = () => {
  // useEffect(() => {

  // }, [])
  return (
    <div>
      <FormAfterSignUp />
    </div>
  );
};

export default FormAfterSignUpPage;
